import { EntityActionNames, IEntityAction } from '~src/spacesPlatform/components/ActionsMenu/EntityActions/IEntityAction';

import { Messages } from '../../codegen/Localize';
import { userIsSubscribedToAnyAlerts } from '../../spacesPlatform/components/ActionsMenu/EntityActions/IEntityActionHelpers';
import { dataAlertAddMe } from '../actions/menuActions/DataAlertMenuActions';
import { IDataAlertInfo } from '../models/IDataAlertInfo';

export const DataAlertAddMeAction: IEntityAction<IDataAlertInfo, {}> = {
  name: EntityActionNames.AddSelf,
  translateName: Messages.addSelfToAlert_action,
  isVisible: (targetItems: IDataAlertInfo[]) => {
    return targetItems.length > 0;
  },
  isClickable: (_availableActions: {}, targetItems: IDataAlertInfo[]) => {
    // only allow clicking is user isn't subscribed to any results
    return !userIsSubscribedToAnyAlerts(targetItems);
  },
  createReduxAction: (targetItems: IDataAlertInfo[]) => dataAlertAddMe(targetItems)
};
